import { Button, Link } from '@skedulo/breeze-ui-react'
import {
  ErrorLevel,
  SKEDULO_SYSTEM_STATUS_URL,
  UIErrorCode,
} from '../constants'

export const buildEmailLink = (
  supportEmail?: string,
  code: UIErrorCode | string = UIErrorCode.UNKNOWN,
  traceId?: string,
) => {
  if (!supportEmail) return

  const subject = `Skedulo Platform Error ${code}${
    traceId ? `, traceId: ${traceId}` : ''
  }`

  return `mailto:${supportEmail}?subject=${encodeURIComponent(subject)}`
}

export const getErrorMessage = (level?: ErrorLevel) => {
  switch (level) {
    case ErrorLevel.HOST:
      return (
        <>
          <div>
            There’s a technical problem that is preventing Skedulo from loading.
            Try logging out and back in again to see if that solves the problem.
            If this doesn’t work please contact your administrator.{' '}
            <Link href={SKEDULO_SYSTEM_STATUS_URL} target="_blank">
              Check platform status
            </Link>
          </div>
          <br />
        </>
      )

    case ErrorLevel.TEMPLATE:
      return (
        <>
          <div>
            There’s a technical problem with Skedulo that is preventing this
            page from loading. Try refreshing this page or going to another
            page. If this doesn’t work please contact your administrator.
          </div>
          <br />
        </>
      )

    case ErrorLevel.OBJECT:
    case ErrorLevel.GROUP:
      return (
        <>
          Unable to load some data on this page due to a technical problem.
          Please try refreshing.
        </>
      )

    case ErrorLevel.COMPONENT:
      return (
        <>
          Unable to load this component due to a technical problem. Please try
          refreshing.
        </>
      )

    default:
      return null
  }
}

export const getErrorCTA = (
  level?: ErrorLevel,
  code?: UIErrorCode | string,
  traceId?: string,
  supportEmail?: string,
) => {
  const mailto = buildEmailLink(supportEmail, code, traceId)

  switch (level) {
    case ErrorLevel.HOST:
      // TODO: Host logout callback? Or eventbus? [ENG-24991]
      return <Button>Log out</Button>

    case ErrorLevel.TEMPLATE:
      return mailto ? (
        <a href={mailto} target="_blank" rel="noreferrer">
          <Button>Contact admin</Button>
        </a>
      ) : null

    case ErrorLevel.OBJECT:
    case ErrorLevel.GROUP:
    case ErrorLevel.COMPONENT:
      return mailto ? (
        <>
          If the problem persists{' '}
          <brz-link href={mailto} target="_blank" rel="noreferrer">
            contact your administrator
          </brz-link>
          .
        </>
      ) : null

    default:
      return null
  }
}
